import { render, staticRenderFns } from "./BioplannerLogo.vue?vue&type=template&id=d0eb216e&scoped=true&"
import script from "./BioplannerLogo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BioplannerLogo.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0eb216e",
  null
  
)

export default component.exports